import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayS } from '@sorare/core/src/atoms/typography';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(Vertical).attrs({ gap: 0 })`
  background-position: center;
  background-size: cover;
  aspect-ratio: 4;
  justify-content: flex-end;
  align-items: flex-start;

  @media ${laptopAndAbove} {
    background-position: center 10%;
  }

  &.fixed {
    height: 124px;
    aspect-ratio: auto;
    @media ${laptopAndAbove} {
      height: 250px;
    }
  }
`;

const Content = styled(Vertical)`
  padding: var(--double-unit) var(--double-unit) 0;
  width: 100%;
  flex-grow: 1;
  @media ${laptopAndAbove} {
    padding: var(--triple-unit) var(--triple-unit) 0;
  }
`;
const Tabs = styled(Horizontal)`
  width: 100%;
  border-bottom: 1px solid var(--c-nd-150);
`;

const LeagueLogo = styled.img`
  height: 48px;
  width: 48px;
  object-fit: contain;
  @media ${tabletAndAbove} {
    height: 80px;
    width: 80px;
  }
`;

const Title = styled(DisplayS)`
  flex-grow: 1;
`;

type Props = {
  backgroundImage: string;
  leagueLogo?: {
    src: string;
    alt: string;
  };
  title?: ReactNode;
  children?: ReactNode;
  fixed?: boolean;
  tabs?: ReactNode;
};

export const Header = ({
  leagueLogo,
  backgroundImage,
  fixed,
  title,
  children,
  tabs,
}: Props) => {
  const { src: leagueLogoSrc, alt: leagueLogoAlt } = leagueLogo || {};
  return (
    <Wrapper
      style={{
        backgroundImage: `linear-gradient(181.8deg, rgba(16, 16, 16, 0.4) 1.52%, #101010 98.48%), url(${backgroundImage})`,
      }}
      className={classNames({ fixed })}
    >
      <Content>
        {children || (
          <>
            {!!leagueLogoSrc && (
              <LeagueLogo src={leagueLogoSrc} alt={leagueLogoAlt} />
            )}
            <Title as="h1">
              {title || (
                <FormattedMessage
                  id="scoutingCenter.title"
                  defaultMessage="Scouting Center"
                />
              )}
            </Title>
          </>
        )}
      </Content>
      <Tabs center>{tabs}</Tabs>
    </Wrapper>
  );
};
